import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComponentesListarComponent } from './pages/componentes/componentes-listar/componentes-listar.component';
import { Error404Component } from './pages/errors/error404/error404.component';
import { Error500Component } from './pages/errors/error500/error500.component';
import { FaturaDetalharComponent } from './pages/fatura/fatura-detalhar/fatura-detalhar.component';
import { FaturaListarComponent } from './pages/fatura/fatura-listar/fatura-listar.component';
import { FaturaSemPermissaoComponent } from './pages/fatura/fatura-sem-permissao/fatura-sem-permissao.component';
import { ConhecaPortalComponent } from './pages/conheca-portal/conheca-portal.component';
import { FaturaEscolhaPagamentoComponent } from './pages/fatura/fatura-escolha-pagamento/fatura-escolha-pagamento.component';

import { FaturaDetalharPixComponent } from './pages/fatura/fatura-detalhar-pix/fatura-detalhar-pix.component';

const routes: Routes = [
  { path: 'listartodoscomponentes', component: ComponentesListarComponent },
  {
    path: 'responsavel/:responsible/aluno/:student/:accesstoken/fichafinanceira',
    component: FaturaListarComponent,
  },
  {
    path: 'fichafinanceira/sempermissao',
    component: FaturaSemPermissaoComponent,
  },
  { path: 'fatura-escolha-pagamento/:id', component: FaturaEscolhaPagamentoComponent },
  { path: 'fatura/:id', component: FaturaDetalharComponent },
  { path: 'fatura-pix/:id', component: FaturaDetalharPixComponent },
  { 
    path: 'conheca-portal', 
    component: ConhecaPortalComponent
  },
  { path: 'error/500', component: Error500Component },
  { path: '', component: Error404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
